import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { fmtEUR } from "../lib/format";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import DocumentsPanel from "../components/documents/DocumentsPanel";
import WorkflowPanel from "../components/workflow/WorkflowPanel";
import OffersPanel from "../components/offers/OffersPanel";
import InvoiceList from "../components/invoices/InvoiceList";
import PianoIncassiPanel from "../components/units/PianoIncassiPanel";
import DatiRogitoPanel from "../components/units/DatiRogitoPanel";
import { useAuth } from "../context/AuthContext";
import { PHASE_COLORS } from "../components/operation/UnitsTab";
import { ArrowLeft, Home, FileDown } from "lucide-react";
import api2 from "../lib/api";

const downloadPdf = async (id, name) => {
  const r = await api2.get(`/checklists/unit/${id}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = `fascicolo_notaio_${name}.pdf`; a.click(); URL.revokeObjectURL(url);
};

export default function UnitDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [u, setU] = useState(null);
  const [op, setOp] = useState(null);
  const [fatRiga, setFatRiga] = useState(null);
  const { user } = useAuth();
  const canWrite = ["super_admin", "amministrazione", "project_manager"].includes(user?.role);
  const load = () => api.get(`/units/${id}`).then((r) => { setU(r.data); return api.get(`/operations/${r.data.operation_id}`); }).then((r) => setOp(r.data)).catch(() => {});
  useEffect(() => { load(); }, [id]);
  if (!u) return <div className="text-muted-foreground">Caricamento unità...</div>;
  return (
    <div className="space-y-5" data-testid="unit-detail">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <Button variant="ghost" size="sm" onClick={() => nav(`/operazioni/${u.operation_id}`)} className="-ml-2 mb-1" data-testid="back-to-operation"><ArrowLeft className="w-4 h-4 mr-1" /> {op?.nome_operazione || "Operazione"}</Button>
          <h1 className="text-3xl font-display font-bold text-primary flex items-center gap-2"><Home className="w-7 h-7" />{u.denominazione_commerciale}</h1>
          <p className="text-sm text-muted-foreground capitalize">{u.codice} · {u.tipologia} · piano {u.piano ?? "—"} · {u.superficie ?? "—"} m² · {u.numero_locali ?? "—"} locali · <Badge variant="outline" className={`capitalize text-white ${PHASE_COLORS[u.stato] || "bg-slate-400"}`}>{u.stato}</Badge></p>
        </div>
        <div className="flex items-start gap-3">
        <Button variant="outline" onClick={() => downloadPdf(id, u.codice)} data-testid="unit-notary-pdf-btn"><FileDown className="w-4 h-4 mr-1" /> Fascicolo notaio PDF</Button>
        <Card className="p-3 grid grid-cols-2 gap-4 text-sm">
          <div><div className="text-xs text-muted-foreground">Prezzo previsto</div><div className="font-semibold kpi-num">{fmtEUR(u.prezzo_previsto)}</div></div>
          <div><div className="text-xs text-muted-foreground">Prezzo vendita</div><div className="font-semibold kpi-num">{u.prezzo_vendita ? fmtEUR(u.prezzo_vendita) : "—"}</div>{u.cliente && <div className="text-xs text-muted-foreground">{u.cliente}</div>}</div>
        </Card>
        </div>
      </div>
      <Tabs defaultValue="incassi">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="incassi" data-testid="utab-incassi">Vendita e incassi</TabsTrigger>
          <TabsTrigger value="proposte" data-testid="utab-proposte">Proposte di vendita</TabsTrigger>
          <TabsTrigger value="documenti" data-testid="utab-documenti">Documenti e checklist rogito</TabsTrigger>
          <TabsTrigger value="workflow" data-testid="utab-workflow">Workflow vendita</TabsTrigger>
          <TabsTrigger value="fatture" data-testid="utab-fatture">Fatture</TabsTrigger>
        </TabsList>
        <TabsContent value="incassi" className="space-y-4"><PianoIncassiPanel unitId={id} canWrite={canWrite} onChanged={load} onFattura={(rid) => setFatRiga({ id: rid, n: Date.now() })} /><DatiRogitoPanel unit={u} canWrite={canWrite} onChanged={load} fatturaRiga={fatRiga} /></TabsContent>
        <TabsContent value="fatture"><InvoiceList operationId={u.operation_id} unitId={id} /></TabsContent>
        <TabsContent value="proposte"><OffersPanel unitId={id} unitPrice={u.prezzo_previsto} /></TabsContent>
        <TabsContent value="documenti"><DocumentsPanel entityType="unit" entityId={id} /></TabsContent>
        <TabsContent value="workflow"><WorkflowPanel entityType="unit" entityId={id} /></TabsContent>
      </Tabs>
    </div>
  );
}
